export default "__VITE_ASSET__CLIHuVeM__"